import { render, staticRenderFns } from "./ObservationPage.vue?vue&type=template&id=2d5aa574&scoped=true&"
import script from "./ObservationPage.vue?vue&type=script&lang=js&"
export * from "./ObservationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5aa574",
  null
  
)

export default component.exports